import { LABEL_HEIGHT_PERCENTAGE } from '../option/Option';

export const getDotRadius = ({
  numberOfDots,
  width,
  height,
}: {
  numberOfDots: number;
  width: number;
  height: number;
}) => {
  if (numberOfDots <= 0 || width <= 0 || height <= 0) {
    return 0;
  }

  const heightOfCluster = height * (1 - LABEL_HEIGHT_PERCENTAGE);
  const side = Math.min(width, heightOfCluster);
  const maxRadius = side * 0.1;
  const containerArea = Math.pow(side, 2);
  const radius = Math.sqrt((0.6 * containerArea) / numberOfDots) / 2;
  return Math.floor(Math.min(radius, maxRadius));
};
